import React, { useState } from 'react';
import { auth, db } from '../firebase'; // Firebase authentication and Firestore
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { setDoc, doc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/Rihal_logo-fullcolor-rgb.svg';

const TouristSignUpPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [photo, setPhoto] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Create the user with email and password
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Prepare the user data
      const userData = {
        name,
        email,
        phone,
        role: 'tourist',
        photoURL: photo || 'https://via.placeholder.com/150', // Default placeholder if no photo is uploaded
      };

      // Save the user data to Firestore
      await setDoc(doc(db, 'users', user.uid), userData);

      // Redirect the user to the tourist profile page
      navigate('/tourist-profile');
    } catch (err) {
      setError(err.message);
    }
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhoto(URL.createObjectURL(file)); // Preview the uploaded photo
    }
  };

  return (
    <div className="relative min-h-screen flex justify-center items-center bg-gradient-to-t from-green-400 to-green-100">
      <img
        src={logo}
        alt="logo"
        className="bg-transparent blur-sm w-full h-full absolute p-40"
      />
      <div className="backdrop-blur-md absolute rounded-3xl bg-transparent shadow-lg w-full max-w-4xl h-max z-20 p-20">
        <h2 className="text-4xl font-semibold text-center mb-20">التسجيل كسائح</h2>
        {error && <p className="text-red-500 text-center mb-6">{error}</p>}
        <form onSubmit={handleSubmit} className="space-y-4 bg-transparent">
          <div>
            <label
              htmlFor="name"
              className="block text-xl mb-4 font-medium text-gray-700"
            >
              الاسم الكامل
            </label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-6 py-4 border-b-4 placeholder:text-gray-900 autofill:bg-transparent active:bg-transparent bg-transparent text-2xl hover:bg-transparent focus:bg-transparent border-green-300 focus:outline-none"
              required
              placeholder="الاسم الكامل"
            />
          </div>
          <div>
            <label
              htmlFor="email"
              className="block text-xl mb-4 font-medium text-gray-700"
            >
              البريد الإلكتروني
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-6 py-4 border-b-4 placeholder:text-gray-900 autofill:bg-transparent active:bg-transparent bg-transparent text-2xl hover:bg-transparent focus:bg-transparent border-green-300 focus:outline-none"
              required
              placeholder="البريد الإلكتروني"
            />
          </div>
          <div>
            <label
              htmlFor="phone"
              className="block text-xl mb-4 font-medium text-gray-700"
            >
              رقم الهاتف
            </label>
            <input
              type="tel"
              id="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="w-full px-6 py-4 border-b-4 placeholder:text-gray-900 placeholder:text-right autofill:bg-transparent active:bg-transparent bg-transparent text-2xl hover:bg-transparent focus:bg-transparent border-green-300 focus:outline-none"
              required
              placeholder="رقم الهاتف"
            />
          </div>
          <div>
            <label
              htmlFor="password"
              className="block text-xl mb-4 font-medium text-gray-700"
            >
              كلمة المرور
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-6 py-4 border-b-4 placeholder:text-gray-900 autofill:bg-transparent active:bg-transparent bg-transparent text-2xl hover:bg-transparent focus:bg-transparent border-green-300 focus:outline-none"
              required
              placeholder="كلمة المرور"
            />
          </div>
          <div>
            <label
              htmlFor="photo"
              className="block text-xl mb-4 font-medium text-gray-700"
            >
              صورة الملف الشخصي
            </label>
            <input
              type="file"
              id="photo"
              onChange={handlePhotoChange}
              className="w-full px-4 py-2 border-b-4 placeholder:text-gray-900 autofill:bg-transparent active:bg-transparent bg-transparent text-2xl hover:bg-transparent focus:bg-transparent border-green-300 focus:outline-none"
            />
            {photo && (
              <img
                src={photo}
                alt="معاينة الصورة"
                className="mt-4 w-24 h-24 rounded-full mx-auto"
              />
            )}
          </div>
          <button
            type="submit"
            className="bg-[#189475] mx-auto text-white text-center text-2xl px-8 py-6 mt-20 rounded-full flex justify-center items-center hover:bg-green-300 transition-colors"
          >
            التسجيل كسائح
          </button>
        </form>
      </div>
    </div>
  );
};

export default TouristSignUpPage;
